const types = {
    READINESS_CHECK_COMPLETE: 'READINESS_CHECK_COMPLETE',
    SET_READINESS_CHECK_VIDEO_POSITION: 'SET_READINESS_CHECK_VIDEO_POSITION',
};

const resultActions = {
    types,

    setReadinessCheckComplete(isReadinessCheckComplete) {
        return { type: types.READINESS_CHECK_COMPLETE, isReadinessCheckComplete };
    },

    setReadinessCheckPosition(videoId, position) {
        return { type: types.SET_READINESS_CHECK_VIDEO_POSITION, videoId, position };
    },
};

export default resultActions;
